import React, { useState, useEffect } from 'react';
import { BarcodeType2, BarcodeType2Create } from '../types/costwand.d';
import { Input } from './ui/input.tsx';
import { Button } from './ui/button.tsx';
import { Label } from '@radix-ui/react-label'; // Using Radix Label for accessibility
import { Spinner } from './ui/spinner.tsx'; // Import Spinner

interface BarcodeType2FormProps {
  initialData?: BarcodeType2 | null;
  onSubmit: (data: BarcodeType2Create) => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  // error?: string | null; // Removed error prop
}

const BarcodeType2Form: React.FC<BarcodeType2FormProps> = ({
  initialData,
  onSubmit,
  onCancel,
  isSubmitting = false,
  // error, // Removed error from destructuring
}) => {
  const [formData, setFormData] = useState<BarcodeType2Create>({
    description: '',
    code: 0,
    created_by: 'tester', // Default value for created_by
  });

  useEffect(() => {
    if (initialData) {
      setFormData({
        description: initialData.description,
        code: initialData.code,
        created_by: initialData.created_by || 'tester', // Use existing or default
      });
    } else {
      setFormData({ description: '', code: 0, created_by: 'tester' });
    }
  }, [initialData]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: id === 'code' ? parseInt(value, 10) || 0 : value, // Parse code to integer
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {/* {error && <p className="text-destructive text-sm">{error}</p>} */} {/* Removed local error display */}
      <div>
        <Label htmlFor="description" className="block text-sm font-medium text-foreground mb-1">Description</Label>
        <Input
          id="description"
          type="text"
          required
          value={formData.description}
          onChange={handleChange}
        />
      </div>
      <div>
        <Label htmlFor="code" className="block text-sm font-medium text-foreground mb-1">Code</Label>
        <Input
          id="code"
          type="number" // Use type number for integer input
          required
          value={formData.code}
          onChange={handleChange}
        />
      </div>
      <div className="flex justify-end gap-2">
        <Button type="submit" disabled={isSubmitting}>
          {isSubmitting ? <span className="flex items-center gap-2"><Spinner size="sm" /> Saving...</span> : 'Save'}
        </Button>
        <Button type="button" variant="outline" onClick={onCancel} disabled={isSubmitting}>
          Cancel
        </Button>
      </div>
    </form>
  );
};

export default BarcodeType2Form;